// Subscription tier configuration
// Stripe Product and Price IDs

export const SUBSCRIPTION_TIERS = {
  starter: {
    name: "Starter",
    productId: "prod_TuECJ84tjsLon8",
    priceId: "price_1SwPjtCyJ98ZYhi4FPcAoip2",
    price: 49,
    jobLimit: 75,
    description: "Perfect for owner-operators with 1-3 vehicles",
  },
  growth: {
    name: "Growth",
    productId: "prod_TuECZ8E6FSEqm0",
    priceId: "price_1SwPkNCyJ98ZYhi4Ho4x6l94",
    price: 99,
    jobLimit: 200,
    description: "Ideal for growing fleets with 4-10 vehicles",
  },
  pro: {
    name: "Pro",
    productId: "prod_TrgFFO22rrUwR0",
    priceId: "price_1StwtMCyJ98ZYhi4CxVWYFrV",
    price: 149,
    jobLimit: null, // Unlimited
    description: "For larger operations with unlimited jobs",
  },
} as const;

export type SubscriptionTierKey = keyof typeof SUBSCRIPTION_TIERS;

export function getTierByProductId(productId: string): SubscriptionTierKey | null {
  for (const [key, tier] of Object.entries(SUBSCRIPTION_TIERS)) {
    if (tier.productId === productId) {
      return key as SubscriptionTierKey;
    }
  }
  return null;
}

export function getTierByPriceId(priceId: string): SubscriptionTierKey | null {
  for (const [key, tier] of Object.entries(SUBSCRIPTION_TIERS)) {
    if (tier.priceId === priceId) {
      return key as SubscriptionTierKey;
    }
  }
  return null;
}

export function getJobLimit(tier: SubscriptionTierKey): number | null {
  return SUBSCRIPTION_TIERS[tier].jobLimit;
}
